import { render, staticRenderFns } from "./ReferralModal.vue?vue&type=template&id=5103a79e&scoped=true&"
import script from "./ReferralModal.vue?vue&type=script&lang=js&"
export * from "./ReferralModal.vue?vue&type=script&lang=js&"
import style0 from "./ReferralModal.vue?vue&type=style&index=0&id=5103a79e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5103a79e",
  null
  
)

export default component.exports